import useCountdownTimer from '@vh/components/VHTimerV2/useCountdownTimer';
import * as Styled from './VHTimerV2.styled';
import React, { useEffect } from 'react';

/** @type {React.FC<{totalTimeInSeconds: number; onTimerComplete?: () => void; disabled?: boolean;}>} */
const VHTimerV2 = ({ totalTimeInSeconds, onTimerComplete, disabled }) => {
  const { formattedTime, startTimer, stopTimer } = useCountdownTimer(
    totalTimeInSeconds,
    onTimerComplete
  );

  useEffect(() => {
    if (!disabled) {
      startTimer(totalTimeInSeconds);
    }
  }, [startTimer, totalTimeInSeconds, disabled]);

  useEffect(() => {
    if (disabled) {
      stopTimer();
    }
  }, [disabled, stopTimer]);

  return (
    <div>
      <Styled.Timer>{formattedTime}</Styled.Timer>
    </div>
  );
};

export default VHTimerV2;
